<div class="container mt-3">
    <div *ngIf="!imageLoading" class="row g-4">
        <strong [innerHTML]="previewData?.categoryName" class="fs-20 mt-0 text-center"></strong>
        <div class="col-md-5 position-relative d-flex flex-column align-items-center">

            @if(previewData?.imagePath && previewData.imagePath.length > 0) {
            <div class="description-image mb-1 d-flex p-2">
                <div class="desc-image-wrapper">
                    <img nz-image [nzSrc]="previewData.imagePath[selectedImageIndex]?.zoomImageUrl"
                        [nzFallback]="fallback" class="rounded img-border img-fluid" alt="ZoomImageUrl">
                </div>
                <div>

                    <div class="d-flex flex-column">
                        @if(previewData?.newProduct) {
                        <img [src]="productImage" class="rounded pe-none thumbnail-link mb-3" alt="ThumbnailImageUrl"
                            nzSrc="error" style="cursor: pointer; width: 50px; height: 50px; object-fit: cover;">
                        }
                        @if(previewData?.catLevel) {
                        <img [src]="catLevelImage" class="rounded pe-none thumbnail-link mb-3" alt="ThumbnailImageUrl"
                            nzSrc="error" style="cursor: pointer; width: 50px; height: 50px; object-fit: cover;">
                        }
                        @if(previewData?.ulClassified) {
                        <img [src]="'IC_BW_UL.png'" class="rounded pe-none thumbnail-link" alt="ThumbnailImageUrl"
                            nzSrc="error" style="cursor: pointer; width: 50px; height: 50px; object-fit: cover;">
                        }
                    </div>

                </div>
            </div>
            <p class="text-center">Click on image to enlarge</p>
            } @else {
            <div class="description-image mb-1">
                <img nz-image [nzSrc]="fallback" [nzFallback]="fallback" class="rounded img-border img-fluid"
                    alt="ZoomImageUrl">
            </div>
            }
            @if(previewData?.imagePath && previewData.imagePath.length > 1) {
            <div
                class="d-flex justify-content-start gap-2 stacked-image flex-nowrap overflow-x-auto pb-2 w-100 custom-scrollbar">
                @for(image of previewData?.imagePath; track $index) {
                <img [src]="image.thumbnailImageUrl" class="rounded thumbnail-link flex-shrink-0"
                    alt="ThumbnailImageUrl" nzSrc="error" [class.active-border]="$index === selectedImageIndex"
                    (click)="setPreview($index)" style="cursor: pointer; width: 60px; height: 60px; object-fit: cover;">
                }
            </div>
            }
        </div>
        <div class="col-md-7 description-block d-flex flex-column">
            <strong [innerHTML]="previewData?.description" class="pb-3 fs-16 fw-normal"></strong>

            @if(previewData?.productInfo && previewData?.productInfo?.length > 0) {
            @for (attributeGroup of previewData?.productInfo;track attributeGroup) {
            <div class="attribute-group mb-0">
                @if(previewData?.attributeFormat == 1 ){
                <strong class="d-block mb-1 text-start w-75 fs-16">
                    {{attributeGroup?.displayName}}
                </strong>
                }

                <ul class="mb-0">
                    @for ( attr of attributeGroup?.attributes;track attr) {
                    @for ( val of attr?.attributeValues;track val) {
                    <li class="position-relative ps-1" [innerHTML]="val">
                    </li>
                    }
                    }
                </ul>
            </div>
            }
            @if(previewData?.customField1 || previewData?.customField2 ) {
            <div class="attribute-group mb-0">
                @if(previewData?.attributeFormat == 1 ){
                <strong class="d-block mb-1 text-start w-75 fs-16">
                    Additional Features
                </strong>
                }
                <ul class="mb-0">
                    @if(previewData?.customField1) {
                    <li class="position-relative ps-1" [innerHTML]="previewData?.customField1">
                    </li>
                    }
                    @if(previewData?.customField2) {
                    <li class="position-relative ps-1" [innerHTML]="previewData?.customField2">
                    </li>
                    }
                </ul>
            </div>
            }
            } @else {
            <div class="text-center mt-4">
                <h6 class="text-muted">No Product Details Found</h6>
            </div>
            }

        </div>
    </div>
    <app-spinner class="row g-4" *ngIf="imageLoading"></app-spinner>
</div>